import { Link } from 'react-router-dom';
import { Course } from '../../../types/course';

interface CourseCardProps {
  course: Course;
}

export function CourseCard({ course }: CourseCardProps) {
  const capsuleCount = course.capsules.length;

  return (
    <Link
      to={`/courses/${course.slug}`}
      className="card"
      style={{ textDecoration: 'none', color: 'inherit' }}
    >
      <div className="card-body" style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-sm)' }}>
        <h3 style={{ fontSize: 18, fontWeight: 600 }}>{course.title}</h3>
        {course.artist && (
          <p style={{ fontSize: 14, color: 'var(--color-text-secondary)' }}>{course.artist}</p>
        )}
        {course.description && (
          <p style={{ fontSize: 13, color: 'var(--color-text-muted)', lineHeight: 1.5 }}>
            {course.description}
          </p>
        )}
        <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-sm)', marginTop: 'var(--space-xs)' }}>
          <span className="badge" style={{ background: 'var(--color-accent-subtle)', color: 'var(--color-accent)' }}>
            {capsuleCount} {capsuleCount === 1 ? 'שיעור' : 'שיעורים'}
          </span>
        </div>
      </div>
    </Link>
  );
}
